import { render, staticRenderFns } from "./DataBox.vue?vue&type=template&id=ff802886"
import script from "./DataBox.vue?vue&type=script&lang=js"
export * from "./DataBox.vue?vue&type=script&lang=js"
import style0 from "./DataBox.vue?vue&type=style&index=0&id=ff802886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports